import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import App2 from "./App2";

ReactDOM.render(<StrictMode><App2 /></StrictMode>, document.getElementById("root"));
